import ButtonStyleField from '@admin/components/mjson_designer/components/buttonstylefield'
import ResponsiveField from '@admin/components/mjson_designer/components/responsivefield'
import FlexField from '@admin/components/mjson_designer/components/flexfield'
import { normalizeConfig } from '../../../utils'
import Form from '@admin/components/form'
import * as styles from '../styles'
import settings from '../settings'
import PropTypes from 'prop-types'
import React from 'react'

const Flex = (props) => <ResponsiveField { ...props } component={ FlexField } />

class EditForwardBlock extends React.PureComponent {

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, theme, type } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              instructions: 't(Contacts can forward this email to a friend using our "Forward to a Friend" form. You can customize the text that appears on the button.)',
              fields: [
                { label: 't(Text)', name: 'content.text', type: 'textfield', defaultValue: 'Forward to a Friend', value: config.content.text, required: true }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 't(Button)',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Display)', name: 'styles.display', canHover: false, type: Flex, omitFeatures: ['width','height'], device, options: [
                  { value: 'block', text: 't(Block)' },
                  { value: 'inline', text: 't(Inline)' }
                ], defaultValue: {
                  desktop: {
                    display: 'inline',
                    align: 'center'
                  },
                  tablet: {
                    display: 'inline',
                    align: 'center'
                  },
                  mobile: {
                    display: 'block'
                  }
                }, value: config.styles.display },
                { label: 't(Button)', name: 'styles.button', device, theme, type: ButtonStyleField, defaultValue: {
                  preset: 'primary_button'
                }, value: config.styles.button }
              ]
            },
            styles.BackgroundSection(config, device, theme, type),
            styles.BorderSection(config, device, theme, type),
            styles.SpacingSection(config, device, theme, type),
            styles.VisibilitySection(config, device, theme, type)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default EditForwardBlock
